module.exports = require("next/link");